import { useState } from "react";

export default function PersonalInfoForm({ onNext }) {
  const [form, setForm] = useState({
    name: "",
    surname: "",
    email: "",
    address: "",
    city: "",
    postalCode: "",
    state: "",
    phone: "",
    domain_id: 123,
    amount: 25,
  });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onNext(form);
      }}
      className="space-y-6"
    >
      <h2 className="text-2xl font-bold mb-4 text-black">Dati di fatturazione</h2>

      <div className="flex gap-4">
        <input
          name="name"
          placeholder="Nome"
          required
          className="flex-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
          onChange={handleChange}
          value={form.name}
        />
        <input
          name="surname"
          placeholder="Cognome"
          required
          className="flex-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
          onChange={handleChange}
          value={form.surname}
        />
      </div>

      <input
        name="email"
        type="email"
        placeholder="Email"
        required
        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
        onChange={handleChange}
        value={form.email}
      />

      <input
        name="address"
        placeholder="Indirizzo (via, numero civico)"
        required
        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
        onChange={handleChange}
        value={form.address}
      />

      <div className="flex gap-4">
        <input
          name="city"
          placeholder="Città"
          required
          className="flex-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
          onChange={handleChange}
          value={form.city}
        />
        <input
          name="postalCode"
          placeholder="CAP"
          required
          className="flex-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
          onChange={handleChange}
          value={form.postalCode}
        />
      </div>

      <input
        name="state"
        placeholder="Provincia / Regione / Stato"
        required
        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
        onChange={handleChange}
        value={form.state}
      />

      <input
        name="phone"
        type="tel"
        placeholder="Telefono (opzionale)"
        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-300"
        onChange={handleChange}
        value={form.phone}
      />

      <button
        type="submit"
        className="text-white px-6 py-2 rounded-full hover:bg-green-700 shadow-md"
        style={{ backgroundColor: "#95c11f", boxShadow: "0 4px 8px rgba(149, 193, 31, 0.4)" }}
      >
        Prosegui al pagamento
      </button>
    </form>
  );
}
